import { render, staticRenderFns } from "./SelectPaginate.vue?vue&type=template&id=68c54328&scoped=true"
import script from "./SelectPaginate.vue?vue&type=script&lang=js"
export * from "./SelectPaginate.vue?vue&type=script&lang=js"
import style0 from "./SelectPaginate.vue?vue&type=style&index=0&id=68c54328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c54328",
  null
  
)

export default component.exports